var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBarricade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_969_3817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 13.5H6.66667C5.83824 13.5 5.16667 14.1716 5.16667 15V28.5C5.16667 29.3284 5.83824 30 6.66667 30H42.6667C43.4951 30 44.1667 29.3284 44.1667 28.5V15C44.1667 14.1716 43.4951 13.5 42.6667 13.5Z",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4167 13.5L32.9167 30",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9167 13.5L44.1667 27.75",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16667 15.75L19.4167 30",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 30V37.5",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 30V37.5",
    stroke: "#4AC6FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_969_3817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#4AC6FF",
    transform: "translate(0.666672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarricade);
export default __webpack_public_path__ + "static/media/icon_barricade.55bb7c5368b1efe6d608bfc1b9f0464b.svg";
export { ForwardRef as ReactComponent };